import { Component } from '@angular/core'
import { PlatformDetectorService } from 'src/app/@core/services/platform-detector/platform-detector.service'
import { ToastType } from 'src/app/@theme/components/toast/toast.model'
import { ToastService } from 'src/app/@theme/components/toast/toast.service'

@Component({
  selector: 'app-browser-empty-state',
  standalone: true,
  imports: [],
  templateUrl: './browser-empty-state.component.html',
  styleUrl: './browser-empty-state.component.scss'
})
export class BrowserEmptyStateComponent {
  constructor(
    private platformDetector: PlatformDetectorService,
    private toast: ToastService
  ) {}

  openInExternalBrowser() {
    const currentUrl = 'https://esporteshub.com/dashboard/feed'

    if (this.platformDetector.isIOS()) {
      window.location.href = `safari-https://${currentUrl.replace('https://', '')}`

      setTimeout(() => {
        const a = document.createElement('a')
        a.setAttribute('href', currentUrl)
        a.setAttribute('target', '_blank')
        a.setAttribute('rel', 'noopener noreferrer')

        a.setAttribute('data-link-type', 'external')
        a.setAttribute('data-force-external', 'true')

        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
      }, 500)
    } else if (this.platformDetector.isAndroid()) {
      window.open(currentUrl, '_system')
    } else {
      window.open(currentUrl, '_blank')
    }
  }

  copyLinkToClipboard() {
    const currentUrl = 'https://esporteshub.com/dashboard/feed'

    // Criar elemento temporário
    const textarea = document.createElement('textarea')
    textarea.value = currentUrl
    textarea.style.position = 'fixed' // Evita rolar a página
    document.body.appendChild(textarea)
    textarea.focus()
    textarea.select()

    try {
      // Executar o comando de cópia
      const successful = document.execCommand('copy')

      this.showToast()
    } catch (err) {
      console.error('Erro ao copiar texto: ', err)
      // Fallback para navegadores modernos
      if (navigator.clipboard) {
        navigator.clipboard
          .writeText(currentUrl)
          .then(() => {
            // Mostrar notificação
            const notification = document.getElementById('copyNotification')
            this.showToast()
          })
          .catch(err => {
            console.error('Erro ao copiar texto: ', err)
          })
      }
    }

    // Remover o elemento temporário
    document.body.removeChild(textarea)
  }

  showToast() {
    this.toast.addToast({
      title: 'Link copiado!',
      message: 'O link foi copiado para sua área de transferência.',
      type: ToastType.SUCCESS
    })
  }
}
